import { render } from "./NDirectors.vue?vue&type=template&id=49b7190d&scoped=true&ts=true"
import script from "./NDirectors.vue?vue&type=script&lang=ts"
export * from "./NDirectors.vue?vue&type=script&lang=ts"

import "./NDirectors.vue?vue&type=style&index=0&id=49b7190d&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b7190d"]])

export default __exports__